export const MESSAGE_FIELDS_EN = {
    txtClaveDosUsuario:'Password',
    txtClaveUsuario:'Password'
}
